import { Link } from "react-router-dom";
import { categoryQuickLinks } from "@/mocks/site";

export default function CategoryQuickLinks() {
  return (
    <section className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {categoryQuickLinks.map((item) => (
          <Link
            key={item.type}
            to={item.path}
            className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-100 p-6 transition-all duration-300 hover:border-accent-300 hover:bg-background-50"
          >
            <div className="flex items-start justify-between">
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className={`${item.icon} text-2xl`} />
              </span>
              <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                {item.count}
              </span>
            </div>
            <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950">
              {item.label}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              {item.desc}
            </p>
            <span className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-accent-600">
              进入分类
              <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}